//计费模拟测试
<template>
  <l-layout :layout="['xs12']" bottom-space>
    <v-form ref="form">
      <v-card class="pa-3">
        <v-layout justify-center column>
          <v-flex xs4>
            <v-select label="规则类型" :items="form.typeSelect" v-model="form.type"
                      item-text="name" item-value="value" prepend-icon="$vuetify.icons.title">
            </v-select>
          </v-flex>
          <v-flex xs4>
            <l-autocomplete
              :get-data="searchChargingRule"
              item-text="name"
              label="计费规则选择"
              prepend-icon="$vuetify.icons.code"
              v-model="form.rule"
            ></l-autocomplete>
          </v-flex>
          <v-flex xs4>
            <l-select-datetime v-model="form.startDatetime" label="开始时间"></l-select-datetime>
          </v-flex>
          <v-flex xs4>
            <l-select-datetime v-model="form.endDatetime" label="结束时间"></l-select-datetime>
          </v-flex>
          <v-flex xs6>
            <v-text-field label="执行结果" v-model="form.result" prepend-icon="mdi-cash-usd" readonly></v-text-field>
          </v-flex>
          <v-layout justify-center>
            <v-btn class="primary" @click="testRule()" :loading="loading">执行</v-btn>
          </v-layout>
        </v-layout>
      </v-card>
    </v-form>
  </l-layout>
</template>
<script>
import LLayout from '../../ladmin/components/LLayout/LLayout'
import LSelectDatetime from '../../ladmin/components/LSelectDatetime/LSelectDatetime'
export default {
  name: 'testRule',
  components: {LSelectDatetime, LLayout},
  data () {
    return {
      loading: false,
      form: {
        type: '',
        typeSelect: [
          {name: '简单计费规则', value: 'simple'},
        ],
        rule: '',
        ruleSelect: [],
        startDatetime: '',
        endDatetime: '',
        result: ''
      }
    }
  },
  methods: {
    getUserInfo () {
      return JSON.parse(sessionStorage.getItem('loginInfo'))
    },
    async searchChargingRule (val) {
      try {
        let {items} = await this.$store.dispatch('charging/getRuleConfigList', {
          pagination: {page: 1, rowsPerPage: 10},
          search: {key: 'name', value: val},
        })
        return items
      }
      catch (e) {
        this.$L.alert('error', {message: e.message})
        return []
      }
    },
    async testRule () {
      if (this.$refs.form.validate()) {
        let params = {
          'chargingType': 'simple',
          'chargingRuleId': this.form.rule.id,
          'startTime': this.$L.time.toTimeStamp(this.form.startDatetime),
          'endTime': this.$L.time.toTimeStamp(this.form.endDatetime),
          'creator': this.getUserInfo().id
        }
        this.loading = true
        try {
          let res = await this.$store.dispatch('charging/chargingTest', params)
          if (res.data.status + '' === '200') {
            this.$L.alert('success', {message: '计费结果生成成功'})
            this.form.result = res.data.data.result
          }
          else {
            this.$L.alert('error', {message: '测试失败，原因:' + res.data.msg})
          }
        }
        catch (e) {
          console.log(e)
        }
        finally {
          this.loading = false
        }
      }
      else {
        this.$L.alert('error', {message: '表单数据不合法'})
      }
    }
  }
}
</script>
